import React from "react";
import styles from '../RecentOrder/RecentOrder.module.scss';
import { formatDistanceToNow, parse } from 'date-fns';

interface IAuthenticatedDeviceCard {
    device: any;
    handleRemoveDevice: (string) => void;
}
const AuthenticatedDeviceCard: React.FC<IAuthenticatedDeviceCard> = (props) => {
    const { device, handleRemoveDevice } = props;
    const LastLogin = (lastUsedAt) => {
        const localDate = new Date(lastUsedAt + 'Z');
        const relativeTime = formatDistanceToNow(localDate, { addSuffix: true });
        return relativeTime;
    };
    return (
        <>
            <div className={`${styles.recentOrderListWrapper} py-3`}>
                <div
                    className={`d-flex justify-content-between align-items-center gap-3`}
                >
                    <div className={`${styles.deviceListWrapper}`}>
                        {/* <p className={`${styles.orderDate} cz-mb-8 f-s14`}>03/31/2025 - Web Order</p> */}
                        <ul className="_orderIngredients_1ohhh_1582 p-0 mb-0">
                            <ul className="ps-0 pt-0">
                                <div className={styles.titleWrap}>
                                    <li className="font-rale f-s14 fw-light clr-text-grey" key={device.device_name}>
                                        <span> <b className='fw-bold mb-0 mt-3'> Device Name: {device.device_name} </b>  </span>
                                    </li>
                                    {
                                        device.current_device ?
                                            <div className={styles.currentDeviceDiv}>
                                                <p className={styles.currentDeviceTag}> Current Device </p>
                                                {/* <p className={styles.groupOrder}>group order</p> */}
                                            </div>
                                            : null
                                    }
                                </div>
                                <li className="font-rale f-s14 fw-light clr-text-grey text-start" key={device.platform}>
                                    <span> <b className='fw-bold mb-0 mt-3'>Platform: </b> {device.platform} {device.browser} </span>
                                </li>
                                {
                                    device.ip_address ?
                                        <li className="font-rale f-s14 fw-light clr-text-grey text-start" key={device.ip_address}>
                                            <span> <b className='fw-bold mb-0 mt-3'>IP Address: </b> {device.ip_address}</span>
                                        </li>
                                        :
                                        null
                                }
                                {device.country ?
                                    <li className="font-rale f-s14 fw-light clr-text-grey" key={'loc'}>
                                        <span> <b className='fw-bold'>Location: </b> {device.city} {device.state} {device.country} </span>
                                    </li>
                                    : null
                                }
                                {
                                    device?.last_used_at ? 
                                        <li className="font-rale f-s14 fw-light clr-text-grey text-start" key={'last-login'}>
                                            <span> <b className='fw-bold'>Last Login: </b> {LastLogin(device.last_used_at)} </span>
                                        </li>
                                        : null
                                        
                                }
                            </ul>
                        </ul>
                    </div>
                    <div className={`${styles.receiptBtns} d-flex flex-column flex-md-row align-items-end align-items-md-center justify-content-between`}>
                        <div onClick={() => handleRemoveDevice(device.token)} className={`${styles.ordrAgain} font-Visby-cf f-s14 f-w8 cursor-pointer`}>
                            <span className={`f-sm-s14 d-flex align-items-center gap-1 font-rale fw-normal px-3 ${styles.current_device_label}`}> Logout </span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default AuthenticatedDeviceCard;
